@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div class="one" fxLayout="column">
  <h3 style="margin-top: 5px; margin-bottom: 0px" class="text-[14px]">
    <b>
      Lookups allow you to predefine lists that make it easy to select from a list when entering
      data throughout SILQ.
    </b>
    Eg Narrations for time entries.
    <br />
    <br />
    Select the list you want to edit and then add or edit the lookup that you want.
  </h3>
  <br />
  <div class="border-line"></div>
  <br />
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="btn-disp mb-3">
    <mat-form-field fxFlex="30" class="pr-1" class="example" appearance="outline">
      <mat-label>Types</mat-label>
      <mat-select
        (selectionChange)="loadData($event.value)"
        name="lookupguidVal"
        [(ngModel)]="lookupguidVal"
      >
        @for (lookupItem of lookupsData; track lookupItem) {
          <mat-option [value]="lookupItem.LOOKUPGUID">
            {{ lookupItem.LOOKUPFULLVALUE }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div>
      <button
        mat-flat-button=""
        color="accent"
        class="spend-money-button btn-text mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14"
        (click)="getValue()"
      >
        <mat-icon class="fs-21">add</mat-icon>
        Add
      </button>
      <button
        mat-flat-button=""
        color="accent"
        class="spend-money-button mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14"
        (click)="AddDuplicateData()"
      >
        <!-- (click)="addDuplicateActivities('Duplicate')" -->
        <mat-icon class="fs-21">file_copy</mat-icon>
        Duplicate
      </button>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="lookup_main_div">
    <div class="example-container" [ngClass]="class == true ? 'height-458' : 'height-457'">
      <table mat-table [dataSource]="lookupsDataSource" multiTemplateDataRows>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Lookup Value</th>
          <td mat-cell *matCellDef="let element">
            {{ element.LOOKUPFULLVALUE }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th
            mat-header-cell
            *matHeaderCellDef
            style="text-align: end; padding-right: 70px; width: 20px"
          >
            <!-- <button mat-flat-button="" (click)="getValue()"
            class="ml-4 ng-tns-c142-6 mdc-button spend-money-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary mat-mdc-button-base"><span
          class="mat-mdc-button-persistent-ripple mdc-button__ripple"></span><mat-icon role="img"
          class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
          data-mat-icon-type="svg" data-mat-icon-name="plus"
          data-mat-icon-namespace="heroicons_outline"><svg xmlns="http://www.w3.org/2000/svg"
          fill="none" viewBox="0 0 24 24" stroke="currentColor" fit="" height="100%"
          width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
        </svg></mat-icon><span class="mdc-button__label"><span
      class="ml-2 mr-1">Add</span></span><span
    class="mat-mdc-focus-indicator"></span><span matripple=""
  class="mat-ripple mat-mdc-button-ripple"></span><span
class="mat-mdc-button-touch-target"></span></button>     -->
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: end; padding-right: 85px">
            <div>
              <button
                matIconButton
                (click)="toggleRow(element)"
                class="spend-money-dropdown flex items-center border border-black/12 text-black"
              >
                <mat-icon class="items-center justify-center text-2xl">
                  {{ element.expanded ? 'keyboard_arrow_up' : 'edit' }}
                </mat-icon>
              </button>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="header-row-first-group" class="mb-4">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px" class="w-full py-4">
              <mat-form-field appearance="outline" class="w-[300px]" subscriptSizing="dynamic">
                <mat-label>Value</mat-label>
                <input
                  style="color: black"
                  matInput
                  placeholder="Value"
                  name="LOOKUPFULLVALUE"
                  [(ngModel)]="LookupObjectData.LOOKUPFULLVALUE"
                />
              </mat-form-field>

              <!-- Save -->
              <button matButton="filled" color="primary" (click)="saveLookups()">
                @if (isspiner) {
                  <mat-spinner diameter="24"></mat-spinner>
                }
                Save
              </button>

              <!-- Cancel -->
              <button
                matButton="tonal"
                color="warn"
                (click)="isNewLookup = false; maintainFlag = false"
              >
                Cancel
              </button>
            </div>
          </th>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <div
              class="example-element-detail"
              animate.enter="detail-expand-in"
              animate.leave="detail-expand-out"
            >
              <div fxLayout="row" fxLayoutAlign="start center" class="py-4">
                <div class="bottom-section lookup-left lookup-left-wi">
                  <mat-form-field
                    fxFlex="100"
                    class="example pr-1"
                    appearance="outline"
                    subscriptSizing="dynamic"
                  >
                    <mat-label>Value</mat-label>
                    <input matInput placeholder="Value" name="DATAVAL" [(ngModel)]="DATAVAL" />
                  </mat-form-field>
                </div>
                <div class="bottom-section">
                  <div
                    align="center"
                    class="button-block"
                    style="text-align: left; padding-left: 75px"
                  >
                    @if (ShowDuplicateBotton == false) {
                      <button
                        mat-raised-button
                        class="cancel disabled-colore"
                        color="accent"
                        class="ng-tns-c142-6 mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary spend-money-updates mat-mdc-button-base"
                        mat-button
                        (click)="saveLookups('update')"
                      >
                        @if (isspiner) {
                          <mat-spinner diameter="24"></mat-spinner>
                        }
                        Update
                      </button>
                    }
                    @if (ShowDuplicateBotton == false) {
                      <button
                        mat-button
                        color="warn"
                        (click)="DeleteLookups()"
                        class="spend-money-deletes btn-red"
                      >
                        Delete
                      </button>
                    }

                    @if (ShowDuplicateBotton == true) {
                      <button
                        (click)="CollapstExpandedrow()"
                        mat-button
                        color="warn"
                        class="activity-drop-button btn-red"
                      >
                        Cancel
                      </button>
                    }

                    @if (ShowDuplicateBotton == true) {
                      <button
                        mat-raised-button
                        class="cancel disabled-colore"
                        color="accent"
                        class="ng-tns-c142-6 mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary spend-money-updates mat-mdc-button-base"
                        mat-button
                        (click)="saveLookups('DUPLICATE')"
                      >
                        @if (isspiner) {
                          <mat-spinner diameter="24"></mat-spinner>
                        }
                        Duplicate
                      </button>
                    }
                    <!-- <button mat-raised-button class="cancel disabled-colore"
                      (click)="isNewLookup=false;dontSave()"  mat-button
                    color="primary">Don't Save</button> -->
                  </div>
                </div>
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          class="mat-header-row-r"
          mat-header-row
          *matHeaderRowDef="['header-row-first-group']"
          [ngClass]="maintainFlag ? '' : 'hideRow'"
        ></tr>

        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="editLookups(row); highlightedRows = row.LOOKUPGUID"
          [style.background]="highlightedRows == row.LOOKUPGUID ? selectedColore : ''"
          [ngClass]="highlightedRows == row.LOOKUPGUID ? 'row-text-colore' : ''"
          class="example-element-row"
          [class.example-expanded-row]="row.expanded"
        ></tr>

        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']; when: isExpandedRow"
          class="example-detail-row"
        ></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center! text-[14px]" [attr.colspan]="displayedColumns.length">
            There is no data to display.
          </td>
        </tr>
      </table>
    </div>
    <!-- <div class="right_popup_btn">
    <div align="center" class="button-block mb-3">
      <button mat-raised-button class="cancel disabled-colore" color="accent" class="mat-ccent"
      [disabled]="isNewLookup" mat-button cdkFocusInitial (click)="newLokkup()">New</button>

      <button mat-raised-button class="cancel disabled-colore" color="accent" class="mat-ccent"
      [disabled]="isNewLookup" mat-button cdkFocusInitial (click)="newDemo()">New</button>
      <button mat-raised-button class="cancel disabled-colore" color="accent" class="mat-ccent"
      [disabled]="isNewLookup" mat-button (click)="isNewLookup=true">Edit</button>
      <button mat-raised-button class="cancel disabled-colore" (click)="DeleteLookups()"
      [disabled]="isNewLookup" mat-button color="primary">Delete</button>
    </div>
  </div> -->
  </div>
  <!-- <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
<div class="bottom-section lookup-left lookup-left-wi">
  <mat-form-field fxFlex="100" class="pr-1" class="example" appearance="outline">
    <mat-label>Value</mat-label>
    <input matInput placeholder="Value" name="LOOKUPFULLVALUE"
      [(ngModel)]="LookupObjectData.LOOKUPFULLVALUE">
    </mat-form-field>
  </div>
  <div class="bottom-section right_popup_btn">
    <div align="center" class="button-block mb-3">
      <button mat-raised-button class="cancel disabled-colore" color="accent" class="mat-ccent"
        [disabled]="!isNewLookup || isspiner" mat-button (click)="saveLookups()">
        <mat-spinner *ngIf="isspiner"></mat-spinner>Save
      </button>
      <button mat-raised-button class="cancel disabled-colore" (click)="isNewLookup=false"
      [disabled]="!isNewLookup" mat-button color="primary">Don't Save</button>
    </div>
  </div>
</div> -->
</div>
